import React from 'react';
import {
  Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Container,
  Heading,
  Text,
  Button,
  VStack,
  Icon,
} from '@chakra-ui/react';
import { FaHome, FaSearch } from 'react-icons/fa';
import SEO from './SEO.jsx';

const NotFound = () => {
  return (
    <Box minH="100vh" bgGradient="linear(to-br, purple.50, white, gold.50)" display="flex" alignItems="center">
      <SEO title="Página no encontrada" noIndex />
      <Container maxW="lg" textAlign="center">
        <VStack gap={6}>
          <Text fontSize="9xl" fontWeight="900" color="purple.200" lineHeight="1">
            404
          </Text>
          <Heading as="h1" size="xl" color="gray.700">
            Página no encontrada
          </Heading>
          <Text fontSize="lg" color="gray.500" maxW="md">
            Lo sentimos, la página que buscas no existe o ha sido movida.
          </Text>
          <VStack gap={3} pt={4}>
            <Button colorPalette="purple" size="lg" rounded="full" px={8} asChild><RouterLink to="/"><Icon asChild><FaHome /></Icon>Ir al inicio
                                          </RouterLink></Button>
            <Button variant="ghost" colorPalette="purple" asChild><RouterLink to="/ayuda"><Icon asChild><FaSearch /></Icon>Centro de ayuda
                                          </RouterLink></Button>
          </VStack>
        </VStack>
      </Container>
    </Box>
  );
};

export default NotFound;
